import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Icon from '../../elements/Icon';
import Button from '../../elements/Button';
import { fullMonths } from '../../../helpers/localization/localizationUtils';

/**
 * @description Determine if the focus is on the current month
 * @param {Date} previousMonth
 * @param {Function} onPreviousClick
 */
const isCurrentMonth = (previousMonth) => {
  return dayjs(dayjs(previousMonth).format('MM/DD/YYYY')).isBefore(
    dayjs().startOf('month').format('MM/DD/YYYY')
  );
};

const DatePickerNav = (props) => {
  const {
    onPreviousClick,
    onNextClick,
    nextMonth,
    previousMonth,
    color,
    iconPrevious,
    iconNext,
    tabIndex,
    iconPrevProps,
    iconNextProps,
    toMonth,
  } = props;
  const { direction, translate, localizationData, theme } = useContext(Context);
  const [className] = useStyles(props, { direction, theme });
  const months = fullMonths(translate, localizationData);
  const disabledNextMonth =
    toMonth && nextMonth && dayjs(toMonth).add(1, 'month').month() === dayjs(nextMonth).month();

  return (
    <Box className="front10-date-selector-nav">
      <Button
        floatLeft
        color={color}
        cursor={isCurrentMonth(previousMonth) ? 'default' : 'pointer'} // TODO: try to avoid doing this checks inside of the render
        className={className}
        name={translate('cmp-datepicker-prev-month', 'Previous month')}
        dataTestId="previousMonthBtn"
        ariaLabel={`${translate('cmp-datepicker-prev-month', 'Previous month')}, ${
          months[previousMonth.getMonth()]
        }`}
        onClick={isCurrentMonth(previousMonth) ? () => {} : onPreviousClick}
        style={isCurrentMonth(previousMonth) ? { opacity: '0.3' } : {}}
        tabIndex={tabIndex}
      >
        <Icon icon={iconPrevious} rotate {...iconPrevProps} />
      </Button>
      <Button
        floatRight
        color={color}
        cursor={disabledNextMonth ? 'default' : 'pointer'} // TODO: try to avoid doing this checks inside of the render
        className={className}
        name={translate('cmp-datepicker-next-month', 'Next month')}
        dataTestId="nextMonthBtn"
        ariaLabel={`${translate('cmp-datepicker-next-month', 'Next month')}, ${
          months[nextMonth.getMonth()]
        }`}
        onClick={() => onNextClick()}
        tabIndex={tabIndex}
        style={disabledNextMonth ? { opacity: 0.3, cursor: 'unset' } : {}}
      >
        <Icon icon={iconNext} rotate {...iconNextProps} />
      </Button>
    </Box>
  );
};
DatePickerNav.propTypes = {
  color: PropTypes.string,
  nextMonth: PropTypes.objectOf(PropTypes.any).isRequired,
  previousMonth: PropTypes.objectOf(PropTypes.any).isRequired,
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  iconPrevious: PropTypes.string,
  iconNext: PropTypes.string,
  tabIndex: PropTypes.number,
  iconPrevProps: PropTypes.objectOf(PropTypes.any),
  iconNextProps: PropTypes.objectOf(PropTypes.any),
  toMonth: PropTypes.instanceOf(Date),
};

DatePickerNav.defaultProps = {
  color: 'link',
  iconPrevious: 'arrow-left',
  iconNext: 'arrow-right',
  tabIndex: null,
  iconPrevProps: {},
  iconNextProps: {},
  toMonth: null,
};
export default DatePickerNav;
